import React from 'react'
import Button from '@material-ui/core/Button'
import { listFilter } from '../../js/filter'
import Input from '@material-ui/core/Input';


// Property needs
// initList = array of Objects
// callback = function with filtered array - callback
// counter = length of filteredList parent Component - filter not activ needs null
// filterProps = Object props of the initList for filtering
// filterActive true or false

const InputFilter = ({ initList, callback, counter, filterProps, filterActive }) => {
   //console.log(initList, callback, counter, filterProps, filterActive)
    const filterList = (event) => {
        event.preventDefault()
        if(event.target.filterInput.value ==='' || initList.length===0){
            callback(null)
            return null 
        }
        const filter = event.target.filterInput.value
        const filteredArr = listFilter(initList, filter, filterProps)
        callback(filteredArr)
    }

    const resetInput = () => {
        document.getElementById('filterInput').value=''
        callback(null)

    }
    return (
        
        <form onSubmit={(e)=>filterList(e)}>
            <Input 
                color='primary'
                id='filterInput'
                name='filterInput'
                style={{marginBottom: '16px', marginRight: '8px'}}
                placeholder="Suchen"
                //className={classes.input}
                inputProps={{
                    'aria-label': 'Description',
                }}
                autoFocus

            />
            <Button type='submit' variant='contained' color='primary' size='small' >Suchen</Button>
            
            {filterActive
                    ? <span style={counter===0 ? {color: 'red', margin: '0 8px 0 8px'} : {margin: '0 8px 0 8px'}}>
                        <Button style={{marginRight: '2px'}} variant='contained' color='secondary' size='small' onClick={resetInput}>Filter löschen</Button>
                        <span style={{margin: '0 16px 0 16px'}}><strong>{document.getElementById('filterInput').value}</strong> ergab {counter} Treiffer!</span>
                    </span> 
                    : <span style={{margin: '0 16px 0 16px'}}>Gesamt {initList.length} Datensätze</span>
            }
        </form>
    )
}

export default InputFilter


// WEBPACK FOOTER //
// ./src/Container/Filter/InputFilter.js